import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
const useStyles = makeStyles(theme => ({
  item: {
    display: "inline-block",
    height: 10,
    width: 10,
    borderRadius: "50%",
    backgroundColor: theme.palette.primary.main,
    margin: "16px 6px 12px"
  },
  itemLight: {
    display: "inline-block",
    height: 10,
    width: 10,
    borderRadius: "50%",
    backgroundColor: `${theme.palette.primary.main}40`,
    margin: "16px 6px 12px"
  },
  dotsContainer: {
    display: "block",
    textAlign: "center",
    width: "100%"
  }
}));
const Dots = ({
  items
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.dotsContainer
  }, items.map((item, index) => {
    return /*#__PURE__*/React.createElement("span", {
      className: item ? classes.item : classes.itemLight,
      key: index
    });
  }));
};
Dots.propTypes = {
  items: PropTypes.array
};
export default Dots;